<template>
  <div class="trivia text-dark mt-5" id="link-app">
    <b-card style="background: fuchsia;">
    <b-row no-gutters>
      <b-col md="6">
        <b-card-img src="../assets/trivia-banner.svg" class="rounded-5 bg-white"></b-card-img>
      </b-col>
      <b-col md="6" class="bg-pink align-self-center">
        <b-card-body class="text-light">
          <b-card-img src="../assets/summer vacation.jpg" class="rounded-5 bg-black"></b-card-img>
          <p><b>We're on haitus over the summer -- we'll be back in the fall!</b> </p>
        </b-card-body>
      </b-col>
    </b-row>
    </b-card>
    
    <b-row class="mt-3 text-light">
      <b-col class="bg-black m-1 py-1"><p>Watch the game stream on YouTube.</p><b-button variant="danger" :href="$root.youtube" target="_blank">Goto YouTube</b-button></b-col>
      <b-col class="bg-black m-1 py-1"><p>Participate in the game at Jackbox.tv</p><b-button variant="secondary" v-bind:href="$root.jackbox"  target="_blank">Goto JackBox.tv</b-button></b-col>
    </b-row>

    <b-row class="mt-3 text-light">
      <b-col class="bg-black m-1"><p>Optionally, join the video chat on Skype to see and talk with other players</p>
      <b-button variant="danger" :href="$root.skype" target="_blank">Open Skype</b-button></b-col>
    </b-row>

    <b-embed
  type="embed"
  :src="$root.youtube_embed"
  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen
  />

  <b-modal id="modal-1" ref="modal-1" hide-backdrop visible="true" title="We're taking a break...">
    <b-card-img src="../assets/summer vacation.jpg" class="rounded-5 bg-black"></b-card-img>
    <p class="my-4">Trivia is on hiatus over the summer.  Stay tuned to insta and facebook for any upcoming events!</p>
  </b-modal>

  </div>

</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Trivia',
  methods: {
      showModal() {
        this.$refs['modal-1'].show()
      },
      hideModal() {
        this.$refs['my-modal'].hide()
      }
    },
  mounted() {
    this.showModal()
  }
}
</script>